import { getInitParams } from 'utils';
import axios from 'axios';

const { REACT_APP_PROPERTIES_BUCKET, REACT_APP_PROPERTIES_BUCKET_X_API_KEY } = process.env;
const { language, propertyId } = getInitParams();

export const genericUrlApi = () => {
  return `${REACT_APP_PROPERTIES_BUCKET}/v1/${language}/${propertyId}`;
};

export const propertyUrlApi = () => {
  return `${genericUrlApi()}/property`;
};

export const flyersUrlApi = (location) => {
  const url = new URL(`${genericUrlApi()}/flyers`);
  url.searchParams.set('lat', location.lat);
  url.searchParams.set('lng', location.lng);
  return url.toString();
};

export const flyersCustomUrlApi = (location, storeCustomLabel, flyerCustomLabel) => {
  const url = new URL(`${genericUrlApi()}/customResources/flyers`);
  if (location?.lat && location?.lng) {
    url.searchParams.set('lat', location.lat);
    url.searchParams.set('lng', location.lng);
  }
  if (storeCustomLabel) url.searchParams.set('customerCode', storeCustomLabel);
  if (flyerCustomLabel) url.searchParams.set('label', flyerCustomLabel);
  return url.toString();
};

export const flyerUrlApi = (flyerId, location, storeCustomLabel) => {
  const url = new URL(`${genericUrlApi()}/flyers/${flyerId}`);
  if (location?.lat && location?.lng) {
    url.searchParams.set('lat', location.lat);
    url.searchParams.set('lng', location.lng);
  }
  if (storeCustomLabel) url.searchParams.set('customerCode', storeCustomLabel);
  return url.toString();
};

export const flyerWithCustomLabelUrlApi = (flyerCustomLabel, customerStoreCode) => {
  const url = new URL(`${genericUrlApi()}/customResources/flyer/${flyerCustomLabel}`);
  if (customerStoreCode) {
    url.searchParams.set('customerCode', customerStoreCode);
  }
  return url.toString();
};

export const flyerStoresUrlApi = (flyerId, location, limit, epochTime, storeCustomLabel) => {
  const url = new URL(`${genericUrlApi()}/flyers/${flyerId}/stores`);
  if (location?.lat && location?.lng) {
    url.searchParams.set('lat', location.lat);
    url.searchParams.set('lng', location.lng);
  }
  if (storeCustomLabel) url.searchParams.set('customerCode', storeCustomLabel);
  if (limit) url.searchParams.set('limit', limit);
  if (epochTime) url.searchParams.set('epochTime', epochTime);
  return url.toString();
};

export const flyerCustomStoresUrlApi = (flyerId, location, limit, epochTime, flyerCustomLabel) => {
  const url = new URL(`${genericUrlApi()}/flyers/${flyerId}/stores`);
  if (location?.lat && location?.lng) {
    url.searchParams.set('lat', location.lat);
    url.searchParams.set('lng', location.lng);
  }
  if (flyerCustomLabel) url.searchParams.set('flyerCustomLabel', flyerCustomLabel);

  limit && url.searchParams.set('limit', limit);
  epochTime && url.searchParams.set('epochTime', epochTime);
  return url.toString();
};

export const flyerStoreOpeningHoursUrlApi = (flyerId, storeId) => {
  return `${genericUrlApi()}/flyers/${flyerId}/stores/${storeId}/openingHours`;
};

export const flyerFlyerGibsUrlApi = (flyerId) => {
  return `${genericUrlApi()}/flyers/${flyerId}/flyerGibs`;
};

export const flyerFlyerGibsProductUrlApi = (flyerId, tag) => {
  return `${genericUrlApi()}/flyers/${flyerId}/flyerGibs/${tag}`;
};

export const fetchJson = (...args) =>
  new Promise((resolve, reject) =>
    fetch(...args)
      .then((res) => res.json().then(resolve).catch(reject))
      .catch(reject)
  );

export const fetchResourcesJson = (url) => {
  return new Promise((resolve, reject) => {
    return axios
      .get(url, { headers: { 'x-api-key': REACT_APP_PROPERTIES_BUCKET_X_API_KEY } })
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
